// The dropdown will represent a styled drop down list in a form.
export default {
  name: 'dropdown',
  props: {
    // The human readable name of the field. The component won't attempt to translate this, it expects a ready value.
    title: '',

    // Any additional classes to add to the drop down container, space separated.
    classes: '',

    // The value to show in the field before a value has been selected.
    placeholder: '',

    // The values to have in the dropdown. It should be an array where each item should have the following format:
    // {
    //  'name': 'My field',   // Human readable name of the field.
    //  'value': 'val1',      // Computer readable value.
    //  'preSelected': false  // Optional, set this to "true" if you want this value to be pre-selected instead the placeholder.
    // }
    values: {
      type: Array,
      required: true
    },

    // If you have a number of input fields in a row (this drop down being one of them), but you don't want a title on
    // it, set this to true to force a title placeholder so the drop down isn't offset in height from the other fields
    // in the row.
    forceTitle: false
  },

  data () {
    return {
      isShowing: false
    }
  },

  computed: {
    selectedValue () {
      let ret = null
      this.values.forEach(function (value) {
        if (value.preSelected) {
          ret = value
        }
      })
      return ret === null ? this.values[0] : ret
    }
  },

  mounted () {
    // Check if we have a value we want to set as default instead of the first one, which we'll use as the fallback.
    let preSelectedfound = false
    this.values.forEach(function (item) {
      if (item.preSelected && item.preSelected === true) {
        preSelectedfound = true
      }
    })

    if (!preSelectedfound) {
      this.select(this.values[0])
    }
  },

  // Close the drop down when clicking the document.
  created () {
    document.addEventListener('click', this.documentClickHandler)
  },

  // Cleanup.
  destroyed () {
    document.removeEventListener('click', this.documentClickHandler)
  },

  methods: {
    select (v) {
      this.values.forEach(function (value) {
        value.preSelected = value === v
      })
      this.isShowing = false
      this.$emit('valueSelected', v)
    },

    documentClickHandler () {
      this.isShowing = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdown/script.js